import React from "react"

import styles from "./LoadingModal.module.css"

import Tangram, { balance, handstand, march } from "~/common/Tangram"

type Props = {
  showModal: boolean
  modalText: string
}

const LoadingModal = (props: Props) => {
  const { showModal, modalText } = props

  if (!showModal) {
    return null
  }

  return (
    <div className={styles.container} data-test="loading-seed-modal">
      <div className={styles.messageBox}>
        <Tangram
          tangrams={[balance, handstand, march]}
          initialTangramIndex={0}
          intervalMs={3000}
          className="heartbeat"
          style={{ width: 60 }}
        />

        <div>
          <div className={styles.textBold}>{modalText}</div>
          <div> Breathe... Stretch... Touch your toes </div>
        </div>
      </div>
    </div>
  )
}

export default LoadingModal
